(function () {
  var CONFIG = {
    's34form-hb': {
      list: 'YzXvPD',
      event: 'Requested Hormonal Balance Guide',
      source: 'Hormonal Balance Guide blog'
    },
    's34form-peri': {
      list: 'WpzQEU',
      event: 'Requested Perimenopause Survival Guide',
      source: 'Perimenopause Survival Guide blog'
    }
  };
  var COMPANY = 'XYcitA';

  function bind(root, cfg) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var form = root.querySelector('form');
    var input = root.querySelector('input[type=email]');
    var err = root.querySelector('.s34-err');
    var cap = root.querySelector('.s34-capture');
    var ok = root.querySelector('.s34-ok');
    var btn = root.querySelector('button');
    if (!form || !input || !btn || !err || !cap || !ok) return;
    var btnText = btn.textContent;

    function valid(m) {
      return m.indexOf('@') > 0 && m.lastIndexOf('.') > m.indexOf('@') + 1 && m.length > 5;
    }
    function fail() {
      btn.disabled = false;
      btn.textContent = btnText;
      err.textContent = 'Something went wrong. Please try again.';
      err.style.display = 'block';
    }
    function send(e) {
      if (e && e.preventDefault) e.preventDefault();
      var email = (input.value || '').trim();
      if (!valid(email)) {
        err.textContent = 'Please enter a valid email address.';
        err.style.display = 'block';
        input.focus();
        return false;
      }
      err.style.display = 'none';
      btn.disabled = true;
      btn.textContent = 'Sending...';
      var headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: cfg.source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.list } } }
          }
        })
      }).then(function (r) {
        if (!r.ok) { fail(); return; }
        fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: { source: cfg.source },
                metric: { data: { type: 'metric', attributes: { name: cfg.event } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          })
        }).catch(function () {});
        cap.style.display = 'none';
        ok.style.display = 'block';
      }).catch(fail);
      return false;
    }

    form.addEventListener('submit', send);
    btn.addEventListener('click', send);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) send(e);
    });
    input.addEventListener('input', function () { err.style.display = 'none'; });
  }

  function init() {
    Object.keys(CONFIG).forEach(function (id) {
      bind(document.getElementById(id), CONFIG[id]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
